import { createResource, createSignal, For, Show } from 'solid-js';

// Persetujuan Izin — the HR-admin approval queue for leave (Izin/Sakit/Cuti/
// Tugas). Leave is approved CENTRALLY here by any admin of the active company,
// unlike lembur (overtime), which is approved by the submitter's SPV/Manager/
// Direksi in the employee portal. Approving a request writes a pay_leave row
// the attendance derivation consumes.

async function getJSON(url) {
  const res = await fetch(url);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || ('HTTP ' + res.status));
  return data;
}

const KIND_TONE = { Cuti: 'success', Izin: 'warning', Sakit: 'info', Tugas: 'info' };

export default function PersetujuanIzin() {
  const [list, { refetch }] = createResource(() => getJSON('/api/izin/pending'));
  const [busy, setBusy] = createSignal(0);
  const [msg, setMsg] = createSignal(null);

  async function decide(id, approve) {
    let note = '';
    if (!approve) {
      note = prompt('Alasan penolakan:') || '';
      if (!note.trim()) return;
    }
    setBusy(id);
    setMsg(null);
    const res = await fetch('/api/izin/decide', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id, approve, note }),
    });
    const data = await res.json().catch(() => ({}));
    setBusy(0);
    if (res.ok) {
      setMsg({ ok: true, t: approve ? 'Pengajuan disetujui.' : 'Pengajuan ditolak.' });
      refetch();
    } else {
      setMsg({ ok: false, t: data.error || 'gagal' });
    }
  }

  return (
    <div class="card card-pad">
      <div class="ky-vars-head">
        <h3 class="kg-hist-title">Persetujuan Izin / Cuti</h3>
        <Show when={(list()?.length ?? 0) > 0}>
          <span class="badge warning" style="margin-left:8px">{list().length} menunggu</span>
        </Show>
        <div class="spacer" />
        <button class="btn ghost" disabled={list.loading} onClick={refetch}>
          {list.loading ? 'Memuat…' : 'Muat ulang'}
        </button>
      </div>

      <p class="ky-vars-note">
        Pengajuan izin, sakit, cuti, dan tugas disetujui terpusat oleh admin HR di sini.
        Persetujuan menulis catatan cuti yang dipakai perhitungan absensi. (Lembur tetap
        disetujui atasan masing-masing — SPV/Manager/Direksi — lewat portal karyawan.)
      </p>

      <Show when={msg()}>
        <div class={`kg-verdict ${msg().ok ? 'ok' : 'fail'}`} style="margin:8px 0">{msg().t}</div>
      </Show>

      <Show when={list.error}>
        <div class="kg-verdict fail">{String(list.error.message || list.error)}</div>
      </Show>

      <Show when={list() && list().length === 0}>
        <p class="kg-meta-text">Tidak ada pengajuan izin yang menunggu.</p>
      </Show>

      <For each={list() ?? []}>{(r) =>
        <div class="kary-lembur-row">
          <div class="kary-lembur-when">
            <b>{r.name}</b> <span class="kg-meta-text">{r.nik}{r.department ? ` · ${r.department}` : ''}</span>
            <div>
              <span class={`badge ${KIND_TONE[r.kind] ?? 'info'}`}>{r.kind}</span>{' '}
              {r.fromDate}{r.toDate !== r.fromDate ? ` – ${r.toDate}` : ''}
            </div>
            <Show when={r.reason}><div class="kg-meta-text">{r.reason}</div></Show>
            <Show when={(r.files ?? []).length > 0}>
              <div class="kary-files">
                <For each={r.files}>{(f) =>
                  <a class="kary-file" href={`/api/izin/file/${f.id}`} target="_blank" rel="noopener">📎 {f.origName}</a>
                }</For>
              </div>
            </Show>
            <div class="kg-meta-text">diajukan {r.createdAt}</div>
          </div>
          <div class="spacer" />
          <button class="btn" disabled={busy() === r.id} onClick={() => decide(r.id, false)}>Tolak</button>
          <button class="btn primary" disabled={busy() === r.id} onClick={() => decide(r.id, true)}>Setujui</button>
        </div>
      }</For>
    </div>
  );
}
